<div class="my__campaing" *ngIf="model && user">
  <div class="col-12 list_campaign_pv_group">{{model.PvGroup}}</div>
  <div class="col-auto list_campaign_info">
    <div class="brand"><img *ngIf="model.IdBrand == 1" src="/assets/images/mini-logo-renault.svg" class="brand-img" alt="Renault"><img *ngIf="model.IdBrand == 2" src="/assets/images/mini-logo-dacia.svg" class="brand-img" alt="Renault"></div>
    <img [src]="model.CampaignImageFile.FileUri" width="168px" [alt]="model.CampaignTitle">
  </div>
  <div class="col col-md-6 col-xxl-4 list_campaign_info">
    <div class="row">
      <div class="col-md-6">
        <div>
          <div class="list_campaign_tit">Campaña</div>
          <div class="list_campaign_data campaign-title">{{model.CampaignTitle}}</div>
          <div *ngIf="model.FreeTitle" class="list_campaign_data campaign-title">{{model.FreeTitle}}</div>
        </div>
        <div *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email || model.IdCampaignMedia == LocalCampaignMedia.Sms">
          <div *ngIf="enviados != 0">
            <div class="list_campaign_tit">Envío</div>
            <div class="list_campaign_data time"><i class="fa fa-calendar"></i> {{model.SendDate | date:'dd/MM/yyyy'}} <i class="fa fa-clock-o ms-1"></i> {{model.SendDate | date:'HH:mm'}}</div>
          </div>
          <div *ngIf="(model.IdStatus == 3 || model.IdStatus == 19) && enviados == 0 && desiredDate > actualDate">
            <div class="list_campaign_tit">Fecha prevista de envío</div>
            <div class="list_campaign_data time"><i class="fa fa-calendar"></i> {{model.DesiredDate | date:'dd/MM/yyyy'}} <i class="fa fa-clock-o ms-1"></i> {{model.DesiredDate | date:'HH:mm'}}</div>
          </div>
        </div>
      </div>
      <div *ngIf="model.IdCampaignMedia != LocalCampaignMedia.Telemarketing" class="col-md-6">
        <div>
          <div class="list_campaign_tit">Puntos de Red</div>
          <ng-container *ngFor="let elem of model.DistributorsOrder; let i=index;">
            <div *ngIf="i < 2 || model.DistributorsOrder.length <= 3" class="list_campaign_distributor">{{elem.AccountNumber}} - {{elem.SocialName}}</div>
          </ng-container>
          <!-- <a *ngIf="model.DistributorsOrder.length >= 3" class="list_campaign_distributor_open link-secondary" placement="end" [ngbPopover]="popContent" [popoverTitle]="popTitle">Otros grupos asociados a la campaña</a> -->
          <a *ngIf="model.DistributorsOrder.length >= 3" class="list_campaign_distributor_open link-secondary" (click)="showCampaignDistributors(modal_campaign_distributors, model.DistributorsOrder)">Otros grupos asociados a la campaña</a>
        </div>
        <ng-template #popContent>
          <div class="list_campaign_distributor" *ngFor="let elem of model.DistributorsOrder; let i=index;">
            {{elem.AccountNumber}} - {{elem.SocialName}}
          </div>
        </ng-template>
        <ng-template #popTitle>Puntos de Red asociados a la campaña</ng-template>
      </div>
    </div>
  </div>
  <div class="col-12 col-md col-xxl-1 list_campaign_contacts">
    <div class="list_campaign_tit">Lista de contactos</div>
    <div class="list_campaign_data" *ngIf="modelStatistics">{{modelStatistics.TotalBbdd | number}}</div>
    <div class="list_campaign_data" *ngIf="modelStatisticsTmk">{{modelStatisticsTmk.TotalBbdd | number}}</div>
    <div><i class="fa fa-database"></i></div>
    <div class="list_campaign_data2">{{model.ContactListName}}</div>
  </div>
  <div class="col-12 col-xxl list_campaign_statistics_container" *ngIf="(model.IdCampaignMedia == LocalCampaignMedia.Email || model.IdCampaignMedia == LocalCampaignMedia.Sms) && loaded">
    <div class="row list_campaign_statistics" *ngIf="modelStatistics">
      <div class="col">
        <div class="list_campaign_tit">Éxito</div>
        <div class="list_campaign_data">{{enviados | number}}</div>
        <div *ngIf="modelStatistics.TotalBbdd > 0" class="list_campaign_data2">({{ enviados * 100 / modelStatistics.TotalBbdd | number : '1.0-0'}} %)</div>
      </div>
      <div class="col">
        <div class="list_campaign_tit">Rebote</div>
        <div class="list_campaign_data">{{error | number}}</div>
        <div *ngIf="modelStatistics.TotalBbdd > 0" class="list_campaign_data2">({{ error * 100 / modelStatistics.TotalBbdd | number : '1.0-0'}} %)</div>
      </div>
      <div *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email" class="col">
        <div class="list_campaign_tit">Abiertos</div>
        <div class="list_campaign_data">{{modelStatistics.Abiertos | number}}</div>
        <div *ngIf="enviados > 0" class="list_campaign_data2">({{ modelStatistics.Abiertos * 100 / enviados | number : '1.0-0'}} %)</div>
      </div>
      <div *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email" class="col">
        <div class="list_campaign_tit">Clics</div>
        <div class="list_campaign_data">{{modelStatistics.Clicks | number}}</div>
        <div *ngIf="modelStatistics.Abiertos > 0" class="list_campaign_data2">
          ({{modelStatistics.Clicks * 100 / modelStatistics.Abiertos | number : '1.0-0' }} %)
        </div>
      </div>
      <!-- <div *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email" class="col">
                <div class="list_campaign_tit">Reactividad</div>
                <div class="list_campaign_data">{{reactividad | number : '1.0-0' }}%</div>
            </div> -->
      <div *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email" class="col">
        <div class="list_campaign_tit">Bajas</div>
        <div class="list_campaign_data">{{modelStatistics.OptOut | number}}</div>
        <div *ngIf="modelStatistics.OptOut > 0" class="list_campaign_data2">({{modelStatistics.OptOut * 100 / modelStatistics.TotalBbdd | number : '1.0-0' }} %)</div>
      </div>
      <div class="col">
        <div class="list_campaign_tit">Visitas taller</div>
        <div class="list_campaign_data">{{modelStatistics.VisitaTaller | number}}</div>
        <div *ngIf="enviados > 0" class="list_campaign_data2">({{modelStatistics.VisitaTaller * 100 / enviados | number : '1.0-0' }} %)</div>
      </div>
      <!--
            <div class="col">
                <div class="list_campaign_tit">Facturación</div>
                <div class="list_campaign_data">{{modelStatistics.Facturacion | currency: 'EUR'}}</div>
                <div class="list_campaign_data2">({{(modelStatistics.Facturacion / (modelStatistics.VisitaTaller ? modelStatistics.VisitaTaller : 1)) | currency: 'EUR'}})</div>
            </div>
            -->
    </div>
    <div class="row list_campaign_tools">
      <div class="col-auto list_campaign_status">
        <span class="list_campaign_status_tit">Estado</span>
        <div class="list_campaign_status_badge" [ngClass]="{'success':model.Status=='ENVIADO' || model.Status=='APROBADO', 'blue':model.Status=='PENDIENTE', 'warning':model.Status=='EN PROCESO' || model.Status=='BORRADOR' || model.Status=='PAUSADO', 'danger':model.Status=='ERROR' || model.Status=='RECHAZADO', 'sin_contactos':model.Status=='SIN CONTACTOS'}">{{status}}</div>
      </div>
      <div class="col">
        <div *ngIf="modelStatistics" class="list_campaign_option_buttons">
          <button *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Email" type="button" class="btn-option-eye" (click)="showCampaignHtml()" placement="left" data-bs-toggle="tooltip" data-bs-placement="left" title="Ver e-mail"><span class="visually-hidden">Ver e-mail</span></button>
          <button *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Sms" type="button" class="btn-option-eye" (click)="showCampaignHtml()" placement="left" data-bs-toggle="tooltip" data-bs-placement="left" title="Ver SMS"><span class="visually-hidden">Ver e-mail</span></button>
          <button *ngIf="modelStatistics.TotalBbdd > 0 && model.IdStatus != 11 && model.IdStatus != 21" type="button" class="btn-option-statistics" (click)="goToDetail(model.IdCampaignMedia)" placement="left" data-bs-toggle="tooltip" data-bs-placement="left" title="Estadísticas"></button>
          <button *ngIf="model.IdStatus == 11 && user.CRMFullAccess" type="button" class="btn-option-resume" (click)="continueCampaign()" placement="left" data-bs-toggle="tooltip" data-bs-placement="left" title="Continuar campaña"><span class="visually-hidden">Continuar campaña</span></button>
          <button *ngIf="model.IdStatus == 11 && user.CRMFullAccess" type="button" class="btn-option-delete btn-option-outline" (click)="deleteCampaign()" placement="left" data-bs-toggle="tooltip" data-bs-placement="left" title="Eliminar campaña"><span class="visually-hidden">Eliminar campaña</span></button>
          <button *ngIf="model.IdStatus == 21" type="button" class="btn-option-pen" (click)="getDeclinedReason(model.IdOrder)" placement="left" data-bs-toggle="tooltip" data-bs-placement="left" title="Ver motivo rechazo"><span class="visually-hidden">Ver motivo rechazo</span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="list_campaign_tit" *ngIf="!loaded && model.IdCampaignMedia != LocalCampaignMedia.Telemarketing">Cargando estadísticas... <img class="imageSize" src="assets/images/icons/ico_loading_bar.svg" /></div>
  <div class="col-12 col-md-12 col-xxl list_campaign_statistics_container" *ngIf="model.IdCampaignMedia == LocalCampaignMedia.Telemarketing">
    <div class="row list_campaign_statistics" *ngIf="modelStatisticsTmk">
      <div class="col">
        <div class="list_campaign_tit">Realizadas</div>
        <div class="list_campaign_data">{{modelStatisticsTmk.Realizadas}}</div>
        <div *ngIf="modelStatisticsTmk.TotalBbdd > 0" class="list_campaign_data2">{{ modelStatisticsTmk.Realizadas * 100 / modelStatisticsTmk.TotalBbdd | number : '1.0-0'}}%</div>
      </div>
      <div class="col">
        <div class="list_campaign_tit">Atendidas</div>
        <div class="list_campaign_data">{{modelStatisticsTmk.FinalizaOk}}</div>
        <div *ngIf="modelStatisticsTmk.Realizadas > 0" class="list_campaign_data2">{{ modelStatisticsTmk.FinalizaOk * 100 / modelStatisticsTmk.Realizadas | number : '1.0-0'}}%</div>
      </div>
      <div class="col">
        <div class="list_campaign_tit">Fallidas</div>
        <div class="list_campaign_data">{{modelStatisticsTmk.FinalizaMal}}</div>
        <div *ngIf="modelStatisticsTmk.Realizadas > 0" class="list_campaign_data2">{{ modelStatisticsTmk.FinalizaMal * 100 / modelStatisticsTmk.Realizadas | number : '1.0-0'}}%</div>
      </div>
    </div>
    <div class="row list_campaign_tools">
      <div class="col-md-12">
        <div *ngIf="modelStatisticsTmk && (user.CRMFullAccess || crmOnlyCalls)" class="list_campaign_option_buttons">
          <button type="button" class="btn-option-call" (click)="updateOrderDataStatus()" data-bs-toggle="tooltip" data-bs-placement="left" title="Gestión de llamadas" placement="left"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modal_campaign_distributors let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Puntos de Red de la campaña</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="list_campaign_distributor" *ngFor="let elem of modalCampaignDistributors;">
      {{elem.AccountNumber}} - {{elem.SocialName}}
    </div>
  </div>
</ng-template>